import { render, staticRenderFns } from "./CustomCheckBox.vue?vue&type=template&id=3c8d98c4&"
import script from "./CustomCheckBox.vue?vue&type=script&lang=js&"
export * from "./CustomCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports